// extracted by mini-css-extract-plugin
export default {"formContainer":"styles_formContainer__fmmB2","form":"styles_form__J0FtD"};